import { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { storage } from "../../helpers/storage";

const ScannerDevolucion = ({alumno, handlePrendaDevolucion}) => {

    const [scanResult, setScanResult] = useState(null);
    const [loadingPrenda, setLoadingPrenda] = useState(false);

    const ciclo = storage.get('ciclo');


    useEffect(() => {
        const scanner = new Html5QrcodeScanner('reader', {
            qrbox: {
                width:300,
                height: 300,
            },
            fps: 5
        });

        scanner.render(success, error);

        function success(result) {
            scanner.clear();
            //setScanResult(result);
            handleScannerPrenda(result);

            //handlePrendaDevolucion(result);
        }

        function error(err) {
            //console.warn(err);
        }
    }, []);

    const handleScannerPrenda = (qr) => {

        if( qr.length == 12 ) {

            let oBody = {
                "CodigoPrenda": qr.slice(0, 2),
                "CodigoTalla": qr.slice(2, -7),
                "Serie": qr.slice(-7),
                "IdTienda": 1288,
                "SerieEntregado": qr.slice(-7),
                "IdAlumno": alumno.IdAlumno,
                "IdCicloEscolar": ciclo.IdCicloEscolar
            };
            
            //01XCH0000010
            setLoadingPrenda(true);
            helpHttp().post(`${BASE_API}Entrega/CambiosUniformes`, {
                body: oBody,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then(res => {
                if(res.ITEMS.success) {

                   // let selection = res.ITEMS;

                    /*let arrpPrendas = {
                        IdPrenda: selection.IdPrenda,
                        Prenda: selection.Prenda,
                        Talla: selection.Talla,
                        Codigo: selection.Codigo,
                        Serie: selection.SerieEntregado,
                        Nivel: selection.Nivel,
                        IdAlumno: alumno.IdAlumno
                    };*/

                   // handlePrenda(arrpPrendas, selection, alumno.IdAlumno, alumno.IdEncEntrega);
                } else {
                    console.log(res.ITEMS.Mensaje);

                    setScanResult(res.ITEMS.Mensaje)
                }
                setLoadingPrenda(false);
            });
        } else {
            console.log('entro aqui');
        }
    }

    return (
        <div>
            <h3>{alumno.Nombre} {alumno.ApellidoPaterno} {alumno.ApellidoMaterno}</h3>
            { scanResult
            ? <div>Success: <div>{scanResult}</div></div>
            : <div id="reader"></div>
            }
        </div>
    );
};

export default ScannerDevolucion;